module.exports = __webpack_public_path__ + "static/media/61pic.bbcd5168.jpg";